(function(){
'use strict';
if(window.__elzShop)return;window.__elzShop=true;
var $=function(s,r){return(r||document).querySelector(s)};
var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
function toast(m,o){if(window.elzToast)window.elzToast(m,o||{})}
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}

/* ---------- listing: ajax filters, sort, pagination ---------- */
function listingSwap(url,push){
  var root=$('[data-elz-listing]');if(!root){location.href=url;return}
  var u=new URL(url,location.origin),fu=new URL(u);
  fu.searchParams.set('section_id',root.dataset.section);
  root.classList.add('is-busy');
  fetch(fu.toString()).then(function(r){return r.text()}).then(function(html){
    var d=new DOMParser().parseFromString(html,'text/html');
    ['[data-elz-results]','[data-elz-filterlist]'].forEach(function(sel){var n=$(sel,d),o=$(sel,root);if(n&&o)o.innerHTML=n.innerHTML});
    if(push!==false)history.pushState({},'',u.pathname+u.search);
    root.classList.remove('is-busy');
  }).catch(function(){location.href=url});
}
function formUrl(f){var p=new URLSearchParams();new FormData(f).forEach(function(v,k){if(v!=='')p.append(k,v)});var s=p.toString();return f.getAttribute('action')+(s?'?'+s:'')}
document.addEventListener('change',function(e){var f=document.getElementById('ElzFilterForm');if(f&&e.target.form===f)listingSwap(formUrl(f))});
document.addEventListener('submit',function(e){if(e.target.id==='ElzFilterForm'){e.preventDefault();listingSwap(formUrl(e.target))}});
document.addEventListener('click',function(e){
  var a=e.target.closest('[data-elz-results] .elz-chip,[data-elz-results] .elz-pager a');
  if(a&&a.href){e.preventDefault();listingSwap(a.href);var r=$('[data-elz-listing]');if(r&&a.closest('.elz-pager'))r.scrollIntoView({behavior:'smooth'})}
});
window.addEventListener('popstate',function(){if($('[data-elz-listing]'))listingSwap(location.href,false)});

/* ---------- cart page ---------- */
function cartChange(line,qty,prev,name){
  var root=$('[data-elz-cart]');if(!root)return;
  root.classList.add('is-busy');
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:line,quantity:qty})})
    .then(function(r){return r.json()})
    .then(function(c){
      if(c.status&&c.message){toast(c.message,{type:'error',title:'Cart not updated'});return null}
      return c;
    })
    .then(function(c){
      return fetch('/cart.js').then(function(r){return r.json()}).then(function(cc){$$('[data-elz-cart-count]').forEach(function(n){n.textContent=cc.item_count})}).then(function(){return c});
    })
    .then(function(c){
      return fetch(root.dataset.url+'?section_id='+root.dataset.section).then(function(r){return r.text()}).then(function(html){
        var d=new DOMParser().parseFromString(html,'text/html');var n=$('[data-elz-cart]',d);if(n)root.innerHTML=n.innerHTML;root.classList.remove('is-busy');
        if(c){
          if(qty===0)toast(name+' was removed from your cart.',{type:'info',title:'Item removed'});
          else if(qty>prev)toast(name+' \u00d7 '+qty,{title:'Quantity increased'});
          else toast(name+' \u00d7 '+qty,{type:'info',title:'Quantity decreased'});
        }
      });
    })
    .catch(function(){location.reload()});
}
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-cart-qty],[data-cart-remove]');if(!b)return;
  var row=b.closest('[data-line]');if(!row)return;
  var i=$('input',row),prev=parseInt(i.value,10)||1,qty=0;
  var nm=(($('.elz-line__t',row)||{}).textContent||'Item').trim();
  if(!b.hasAttribute('data-cart-remove'))qty=Math.max(0,prev+parseInt(b.dataset.cartQty,10));
  cartChange(parseInt(row.dataset.line,10),qty,prev,nm);
});
document.addEventListener('change',function(e){
  var i=e.target.closest('[data-cart-input]');
  if(i){var row=i.closest('[data-line]'),nm=(($('.elz-line__t',row)||{}).textContent||'Item').trim();cartChange(parseInt(row.dataset.line,10),Math.max(0,parseInt(i.value,10)||0),parseInt(i.defaultValue,10)||1,nm);return}
  var n=e.target.closest('[data-cart-note]');
  if(n){fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:n.value})}).then(function(){toast('Your order note was saved.',{type:'info',title:'Note saved'})})}
});
document.addEventListener('keydown',function(e){if(e.key==='Enter'&&e.target.closest('[data-cart-input]')){e.preventDefault();e.target.blur()}});

/* ---------- wishlist page ---------- */
function wishRender(){
  var box=$('[data-elz-wishlist]');if(!box)return;
  var list;try{list=JSON.parse(localStorage.getItem('elz_wish')||'[]')}catch(x){list=[]}
  var grid=$('.elz-grid',box),empty=$('[data-wish-empty]',box);
  if(!list.length){grid.innerHTML='';empty.hidden=false;return}
  empty.hidden=true;
  var fmt;try{fmt=new Intl.NumberFormat(undefined,{style:'currency',currency:box.dataset.currency||'USD',maximumFractionDigits:0})}catch(x){fmt={format:function(v){return v}}}
  Promise.all(list.map(function(h){return fetch('/products/'+encodeURIComponent(h)+'.js').then(function(r){return r.ok?r.json():null}).catch(function(){return null})})).then(function(items){
    grid.innerHTML=items.filter(Boolean).map(function(p){
      var img=p.featured_image?'<img class="elz-pc__img elz-pc__img--main" src="'+esc(p.featured_image+(p.featured_image.indexOf('?')>-1?'&':'?')+'width=600')+'" alt="'+esc(p.title)+'" loading="lazy">':'';
      var on=p.compare_at_price>p.price;
      var cmp=on?'<s>'+fmt.format(p.compare_at_price/100)+'</s>':'';
      var off=on?'<span class="elz-pc__off">'+Math.round((p.compare_at_price-p.price)*100/p.compare_at_price)+'% OFF</span>':'';
      var sub=(p.description||'').replace(/<[^>]*>/g,' ').replace(/\s+/g,' ').trim().slice(0,46)||p.type||'';
      return '<div class="elz-pw"><div class="elz-pc" data-url="'+esc(p.url)+'"><a class="elz-pc__media" href="'+esc(p.url)+'">'+img+'</a><div class="elz-pc__body"><a class="elz-pc__link" href="'+esc(p.url)+'"><span class="elz-pc__row"><span class="elz-pc__t">'+esc(p.title)+'</span>'+off+'</span><span class="elz-pc__sub">'+esc(sub)+'</span></a><div class="elz-pc__foot"><span class="elz-pc__price">'+cmp+'<b>'+fmt.format(p.price/100)+'</b></span><a class="elz-pc__buy" href="'+esc(p.url)+'">View</a></div></div></div><button type="button" class="elz-pheart is-on" data-elz-wish="'+esc(p.handle)+'" aria-label="Remove from wishlist"><svg class="elz-svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8 3.4 5 6.6 5c2 0 3.4 1.1 5.4 3.2C14 6.1 15.4 5 17.4 5c3.2 0 5.1 3 3.9 6.3-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg></button></div>';
    }).join('');
  });
}
document.addEventListener('click',function(e){if(e.target.closest('[data-elz-wishlist] [data-elz-wish]'))setTimeout(wishRender,30)});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',wishRender);else wishRender();
})();
